import "./form.scss";
import { CiSearch } from "react-icons/ci";
import { userPlaceholder } from "assets/icons";
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";

import moment from "moment";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";
// ****************** Search box **************************//

export const SearchBar = ({ className, placeholder, ...rest }) => {
  return (
    <>
      <div className={`search_bar ${className}`}>
        <CiSearch />
        <input
          type="search"
          className="form-control input"
          placeholder={placeholder}
          {...rest}
        />
      </div>
    </>
  );
};

// *********************** Button with icon *********************** //

export const IconButton = ({ children, className, button, ...rest }) => {
  return (
    <>
      <button
        type={button}
        className={`button icon_button ${className}`}
        {...rest}
      >
        {children}
      </button>
    </>
  );
};

// export const CustomButton = ({ children, className, ref, ...rest }) => {
//   return (
//     <>
//       <Button variant="contained" ref={ref} className={`button ${className}`} {...rest}>
//         {children}
//       </Button>
//     </>
//   );
// };
export const CustomButton = forwardRef(
  ({ children, className, isLoading, isDisabled, ...rest }, ref) => {
    return (
      <Button
        variant="contained"
        ref={ref} // Pass the ref here
        className={`button ${className}`}
        disabled={isLoading || isDisabled} // Disable button if loading
        {...rest}
      >
        {isLoading ? <span className="loader" /> : children}
      </Button>
    );
  }
);

export default CustomButton;

// *********************** Switch Button *********************** //

export const SwitchButton = ({ className = "", status }) => {
  return (
    <>
      <label className={`switch ${className}`}>
        <input
          type="checkbox"
          checked={status == "true" || status === true}
          readOnly
        />
        <span className="slider round"></span>
      </label>
    </>
  );
};

// Image //

export const Img = ({ src, alt }) => {
  const onImageError = (e) => {
    e.target.src = userPlaceholder;
  };
  return (
    <>
      <img src={src} alt={alt} onError={onImageError} />
    </>
  );
};

export const searchDateFormat = (date) => {
  // return date ? moment(date).format("DD-MM-yyyy") : ""
  return date ? moment(date).format("yyyy-MM-DD") : "";
};

export const CustomLink = ({ to, className, disabled, children, ...rest }) => {
  return disabled ? (
    <Link style={{ cursor: "not-allowed" }} className={className}>{children}</Link>
  ) : (
    <Link to={to} className={className} {...rest}>
      {children}
    </Link>
  );
};
